import { render, staticRenderFns } from "./ResponsibleUsers.vue?vue&type=template&id=c9a11454"
import script from "./ResponsibleUsers.vue?vue&type=script&lang=js"
export * from "./ResponsibleUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports